import React, { useState } from 'react';
import PostListPage from './pages/PostListPage';
import CreatePostPage from './pages/CreatePostPage';
import ChatRoomsPage from './pages/ChatRoomsPage';
import LoginForm from './pages/LoginForm';
import ChatRoomPage from './pages/ChatRoomPage';
import JoinForm from './pages/JoinForm';
import MyProfilePage from './pages/MyProfilePage';

function App() {
  const [page, setPage] = useState('login');
  const [username, setUsername] = useState('');
  const [nickname, setNickname] = useState(''); // 추가
  const [chatRoomId, setChatRoomId] = useState(null);
  const [chatRoomName, setChatRoomName] = useState('');
  const [viewProfileUsername, setViewProfileUsername] = useState('');

  const handleEnterChatRoom = (id, name) => {
    setChatRoomId(id);
    setChatRoomName(name || '');
    setPage('chat');
  };

  const handleViewProfile = (targetUsername) => {
    setViewProfileUsername(targetUsername);
    setPage('viewprofile');
  };

  console.log('현재 로그인 username:', username, 'nickname:', nickname);
  
  return (
    <div>
      {page === 'login' && (     
        <LoginForm 
          onLogin={({ username, nickname }) => {
            setUsername(username);
            setNickname(nickname || username);
            setPage('list');
          }}
          onJoin={() => setPage('join')}
        />
      )}

      {page === 'join' && (
        <JoinForm onSignup={() => setPage('login')} />
      )}

      {page === 'list' && (
        <PostListPage
          onCreatePost={() => setPage('create')}
          onOpenChatRooms={() => setPage('chatrooms')}
          onOpenProfile={() => setPage('myprofile')}
          onEnterChatRoom={handleEnterChatRoom}
          onViewProfile={handleViewProfile}
          username={username}
          nickname={nickname}
        />
      )}

      {page === 'create' && (
        <CreatePostPage
          username={username}
          onPostCreated={() => {
            setPage('list');
          }}
          onBack={() => setPage('list')}
          onOpenChatRooms={() => setPage('chatrooms')}
          onOpenProfile={() => setPage('myprofile')}
        />
      )}

      {page === 'chatrooms' && (
        <ChatRoomsPage
          username={username}
          onEnterChatRoom={handleEnterChatRoom}
          onBack={() => setPage('list')}
        />
      )}

      {page === 'chat' && (
        <ChatRoomPage
          chatRoomId={chatRoomId}
          chatRoomName={chatRoomName}
          username={username}
          onBack={() => setPage('chatrooms')}
          onViewProfile={handleViewProfile}
        />
      )}

      {page === 'myprofile' && (
        <MyProfilePage
          username={username}
          onBack={() => setPage('list')}
        />
      )}

      {page === 'viewprofile' && (
        <MyProfilePage
          username={viewProfileUsername}
          onBack={() => setPage('list')}
          isViewOnly
        />
      )}
    </div>
  );
}

export default App;